var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
var mockInitialState = {
    config: {}
};
var RewardsConfigContext = createContext(mockInitialState);
RewardsConfigContext.displayName = 'RewardsConfigContext';
export var useRewardsConfigContext = function () {
    return useContext(RewardsConfigContext);
};
var RewardsConfigContextProvider = function (_a) {
    var state = _a.state, children = _a.children;
    var contextState = useMemo(function () { return state; }, [state]);
    return (_jsx(RewardsConfigContext.Provider, __assign({ value: contextState }, { children: children })));
};
export default RewardsConfigContextProvider;
